<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <!-- 패트롤부서 -->
        <!-- <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <c-dept
            type="search"
            label="패트롤부서"
            name="period"
            v-model="searchParam.deptCd"
          />
        </div> -->
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <!-- 패트롤기간 -->
          <c-datepicker
            :range="true"
            label="패트롤기간"
            defaultStart="-6M"
            defaultEnd="6M"
            name="period"
            :isToyear="true"
            v-model="period"
          />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="안전보건팀 패트롤 목록"
      rowKey="sopEmergencyTrainingId"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="등록" v-if="editable" :editable="editable" icon="add" @btnClicked="onItemClick" />
          <c-btn label="검색" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'cto',
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            sortable: true,
            style: 'width:100px',
          },
          {
            name: 'ctoCompleteFlagName',
            field: 'ctoCompleteFlagName',
            label: '진행상태',
            align: 'center',
            sortable: true,
            style: 'width:80px',
          },
          {
            name: 'ctoDate',
            field: 'ctoDate',
            label: '패트롤일',
            align: 'center',
            sortable: true,
            style: 'width:100px',
          },
          {
            name: 'mdmSopId',
            field: 'mdmSopId',
            label: '패트롤명',
            align: 'center',
            sortable: true,
            style: 'width:200px',
            type: 'link',
          },
          {
            name: 'observeUserName',
            field: 'observeUserName',
            label: '패트롤자',
            align: 'center',
            sortable: true,
            style: 'width:100px',
          },
          {
            name: 'workArea',
            field: 'workArea',
            label: '작업구역',
            align: 'left',
            sortable: true,
            style: 'width:100px',
          },
          {
            name: 'completeCount',
            field: 'completeCount',
            label: '개선 건 수',
            align: 'center',
            sortable: true,
            style: 'width:80px',
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: null,
        process: '',
        deptCd: '',
        startYmd: '',
        endYmd: '',
        mdmSopId: '',
        sopName: '',
      },
      period: [],
      searchUrl: '',
      editable: true,
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sop.cto.basic.list.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      if (this.period) {
        this.searchParam.startYmd = this.period[0];
        this.searchParam.endYmd = this.period[1];
      } else {
        this.searchParam.startYmd = '';
        this.searchParam.endYmd = '';
      }
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    onItemClick() {
      this.linkClick(null);
    },
    /* eslint-disable no-unused-vars */
    linkClick(row, col, index) {
      this.popupOptions.title = '안전보건팀 패트롤 상세'; // 안전보건팀 패트롤 상세
      this.popupOptions.param = {
        sopCtoId: row ? row.sopCtoId : '',
      };
      this.popupOptions.target = () => import(`${'./ctoDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    openSop() {
      this.popupOptions.title = 'SOP 검색'; // SOP 검색
      this.popupOptions.param = {
        type: 'single',
        searchType: '1', //1: 작업조회, 2:작업단계, 3:작업단계별 유해위험요인, 4:작업단계별 유해위험요인별 원인/결과
      };
      this.popupOptions.target = () => import(`${'@/pages/common/process/sopPop.vue'}`);
      this.popupOptions.width = '70%';
      this.popupOptions.isFull = false;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeSopPopup;
    },
    closeSopPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.searchParam.mdmSopId = data[0].mdmSopId;
        this.searchParam.sopName = data[0].sopName;
      }
    },
    removeSop() {
      this.searchParam.mdmSopId = '';
      this.searchParam.sopName = '';
    },
  }
};
</script>
